module.exports = __webpack_public_path__ + "1f4d06e55d99883665278a0f79f5eea9.svg";